import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../../../Themes/ColorScheme";
import { Spinner } from "../../../Common/Spinner";

export const FormSave = ({ check, handleSave, activity }) => {
	const { t } = useTranslation();

	return (
		<Button
			sx={{
				backgroundColor: ColorScheme.transparent,
				boxShadow: "none",
				padding: "2px",
				width: "100px",
				opacity: check || activity ? 0.6 : 1,
				border: "1px solid " + ColorScheme.transparent,
				"&:hover": {
					backgroundColor: ColorScheme.transparent,
					boxShadow: "none",
					border: "1px solid " + ColorScheme.secondary,
					padding: "2px"
				}
			}}
			variant="contained"
			disabled={activity || check}
			onClick={() => handleSave()}
		>
			{!activity ? <Typography sx={{ textTransform: "none" }}>{t("buttons.save")}</Typography> : <Spinner color={ColorScheme.secondary} size={"24px"} />}
		</Button>
	);
};
